<!-- MitPeopleNameSearch.vue -->
 <template>
  <div>
    <v-autocomplete
      v-model="selectedPerson"
      :items="peopleNames"
      label="Search by Name"
      prepend-icon="mdi-magnify"
      clearable
      item-text="fullName"
      item-value="person"
      solo
      @change="onPersonSelected"
    >
      <template v-slot:item="data">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <a 
                :href="`/user/${data.item.person.csailId}`" 
                >
                {{ data.item.fullName }}
              </a> 
              <span class="caption"                 
                :style="data.item.person.status === 'Active' ? 'color: green;' : data.item.person.status === 'Inactive' ? 'color: red;' : ''">
                ({{ data.item.person.status }})
              </span>
            </v-list-item-title>
            <v-list-item-subtitle>{{ data.item.person.csailId }}</v-list-item-subtitle>
            <v-list-item-subtitle>Supervisor: {{ data.item.person.supervisor }}</v-list-item-subtitle>
            <v-list-item-subtitle>{{ data.item.person.roles }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  name: 'MitPeopleNameSearch',
  props: {
    people: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedPerson: null,
    };
  },
  computed: {
    peopleNames() {
      return this.people.map((person) => ({
        fullName: `${person.fname} ${person.lname}`,
        person: person,
      }));
    },
  },
  methods: {
    onPersonSelected() {
      if (this.selectedPerson) {
        this.$emit('update:filteredPeople', [this.selectedPerson]);
      } else {
        this.$emit('update:filteredPeople', this.people);
      }
    },
  },
};
</script>

<style scoped>
</style>
